import { AuthRepository } from "../repositories/AuthRepository";

/**
 * Update Zoho Token Use Case
 * Handles updating user's Zoho refresh token
 */
export class UpdateZohoTokenUseCase {
  constructor(private authRepository: AuthRepository) {}

  /**
   * Execute Zoho token update
   * @param refreshToken - Zoho refresh token
   */
  async execute(refreshToken: string): Promise<void> {
    // Validate token
    if (!refreshToken || refreshToken.trim() === "") {
      throw new Error("Zoho refresh token is required");
    }

    // Update token through repository
    await this.authRepository.updateZohoToken(refreshToken);
  }
}
